"use client";

import { useEffect, useRef } from "react";
import { usePathname } from "next/navigation";
import NProgress from "nprogress";

NProgress.configure({ showSpinner: false, trickleSpeed: 150, minimum: 0.08 });

const MIN_DISPLAY_MS = 350;

export function NavigationProgress() {
  const pathname = usePathname();
  const startedAt = useRef<number>(0);

  // Navigation complete — finish the bar, but keep it visible for at least MIN_DISPLAY_MS
  useEffect(() => {
    const elapsed = Date.now() - startedAt.current;
    const remaining = Math.max(0, MIN_DISPLAY_MS - elapsed);
    const timer = setTimeout(() => NProgress.done(), remaining);
    return () => clearTimeout(timer);
  }, [pathname]);

  // Intercept link clicks to start the bar
  useEffect(() => {
    function handleClick(e: MouseEvent) {
      const anchor = (e.target as Element).closest("a[href]");
      if (!anchor) return;
      const href = anchor.getAttribute("href")!;
      if (href.startsWith("http") || href.startsWith("mailto") || href.startsWith("#")) return;
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      startedAt.current = Date.now();
      NProgress.start();
    }

    document.addEventListener("click", handleClick, true);
    return () => document.removeEventListener("click", handleClick, true);
  }, []);

  return null;
}
